import { render, staticRenderFns } from "./ExtraDaysOverview.vue?vue&type=template&id=01541e8f&"
import script from "./ExtraDaysOverview.vue?vue&type=script&lang=js&"
export * from "./ExtraDaysOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports